import VueTypes, { nullable } from "vue-types";


export const ServicesCompositionItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    title: VueTypes.string.isRequired,

    description: VueTypes.oneOfType([String, nullable]).def(null),
    image: VueTypes.oneOfType([String, nullable]).def(null),
    icon: VueTypes.oneOfType([String, nullable]).def(null),
    link: VueTypes.oneOfType([String, nullable]).def(null),
}).isRequired;


export const createServicesCompositionItem = ({ 
    id, title, description, image, icon, link
}) => {
    return {
        id: id,
        title: title,
        description: description,
        image: image,
        icon: icon,
        link: link,
    }
}


// MOCKS
// ServicesCompositionItem
// {
//     id: 1,
//     image: 'https://admin.ecom.md/media/services/image_29_1.png',
//     icon: 'https://admin.ecom.md/media/services/Truck.png',
//     title: 'Luarea măsurilor',
//     description: 'Măsurătorul nostru va ajunge la un moment convenabil pentru dvs., va lua toate măsurătorile necesare ale ușii, va coordona detaliile și le va înregistra în scris',
//     link: '/',
// },